import { Box, Card } from '@betterment/samba-react';
import { CardLoader } from '@betterment/shared-components/src/components/card-loader/card-loader';
import { BalanceChart as SharedBalanceChart } from '@betterment/shared-components/src/components/charts';
import { ParentSize } from '@visx/responsive';

import { UserBalancePerformanceQuery } from './graphql/userPerformanceBalance.generated';

export type BalanceChartProps = {
  history: UserBalancePerformanceQuery['performance']['history'] | undefined;
  balanceDetailsId: string;
};

export const BalanceChart: React.FC<BalanceChartProps> = ({ history, balanceDetailsId }) => {
  if (!history) {
    return <CardLoader />;
  }

  return (
    <Card>
      <Card.Content>
        <Box css={{ padding: 'space.300', height: '500px' }}>
          <ParentSize debounceTime={10}>
            {({ width, height }) => (
              <SharedBalanceChart
                data={history.timeSeries}
                width={width}
                height={height}
                aria-describedby={balanceDetailsId}
                aria-label="Balance Chart"
              />
            )}
          </ParentSize>
        </Box>
      </Card.Content>
    </Card>
  );
};
